import { TableContainer, Table, Box, SxProps, Theme } from "@mui/material";
import CardBox from "../CardBox";
import RopTableHeader from "./RopTableHeader";
import RopTableBody from "./RopTableBody";
import { RopTablePageSelector } from "./RopTablePageSelector";
import RopTableSearch from "../RopTableSearch";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import BaseButton from "../BaseButton";

export type TableItem = {
  item: React.ReactNode;
  align?: "inherit" | "left" | "center" | "right" | "justify";
  isMobile?: boolean;
  width?: string | number;
};
export type TableRowType = { rowItems: TableItem[]; onClick?: () => void };

export type RopTableProps = {
  hover?: boolean;
  itemsHeaders?: TableItem[];
  itemsSubHeaders?: TableItem[];
  itemRows?: TableRowType[];
  isLoading?: boolean;
  itemsAmount?: number;
  rowsPerPage?: number;
  page?: number;
  setPage?: (page: number) => void;
  setRowsPerPage?: (rowsPerPage: number) => void;
  search?: string;
  setSearch?: (search: string) => void;
  maxHeigth?: number | string;
  sxCardBox?: SxProps<Theme>;
  itemFooter?: TableRowType;
  onClickExportButton?: () => void;
  searchPlaceholder?: string;
  headerChildren?: React.ReactNode;
};

export default function RopTable(props: RopTableProps) {
  return (
    <>
      {props.setSearch && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: { md: "flex-end", xs: "center" },
            marginBottom: "10px",
            marginTop: "10px",
            flexDirection: props.onClickExportButton || props.headerChildren ? "row" : "column",
            paddingRight: { md: "15px", xs: "0px" },
            justifyContent: props.onClickExportButton || props.headerChildren ? "space-between" : undefined,
          }}
        >
          <RopTableSearch
            search={props.search || ""}
            setSearch={props.setSearch ? props.setSearch : () => { }}
            placeholder={props.searchPlaceholder}
          />
          <Box>
            {props.headerChildren}
            {props.onClickExportButton && (
              <BaseButton
                onClick={props.onClickExportButton}
                title="Exportar CSV"
                startIcon={<FileDownloadIcon />}
                sx={{ width: "fit-content" }}
              />)}
          </Box>
        </Box>
      )}
      <CardBox
        sx={{
          width: "calc(100% - 20px)",
          // maxHeight: { sm: props.maxHeigth ?? "85vh" },
          maxHeight: { sm: props.maxHeigth ?? "85vh" },
          display: "flex",
          flexDirection: "column",
          margin: "10px",
          ...props.sxCardBox,
        }}
      >
        <TableContainer>
          <Table aria-label="simple table">
            <RopTableHeader itemsHeaders={props.itemsHeaders || []} />
            <RopTableHeader itemsHeaders={props.itemsSubHeaders || []} />
            <RopTableBody
              hover={props.hover}
              isLoading={props.isLoading}
              itemRows={props.itemRows}
              itemsHeaders={props.itemsHeaders}
              itemFooter={props.itemFooter}
            />
          </Table>
        </TableContainer>
      </CardBox>
      {props.page && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: { md: "flex-end", xs: "center" },
            flexDirection: "column",
            paddingRight: { md: "5px", xs: "0px" },
          }}
        >
          <RopTablePageSelector
            itemsAmount={props.itemsAmount || 0}
            rowsPerPage={props.rowsPerPage || 0}
            page={props.page || 0}
            setPage={props.setPage ? props.setPage : () => { }}
            setRowsPerPage={
              props.setRowsPerPage ? props.setRowsPerPage : () => { }
            }
          />
        </Box>
      )}
    </>
  );
}
